<template>
<div class="col-lg-12 col-md-12 col-sm-12 p-0">
    <ToastNotification :toastMsgType="state.toastMsgType"  :messageFromServer="state.messageFromServer" v-if="state.messageFromServer!='' && state.toastMsgType !=''"></ToastNotification>
    <ApplicationOverview v-if="currentStage == 3" :scpaDetails="scpaDetails" :completedb="completedb" :generateQuoteData="generateQuoteData" :proposalDetailsData="proposalDetailsData"/>
    <PaymentMethods @radioButtonMode="shareButton" @paymentBtnSatus="paymentBtn" :partyId="completedb.generateQuote.partyId"
    :motorQuoteApplicability="completedb.generateQuote.policyDetails.motorQuoteApplicability" :customerMobileNo="proposalDetailsData.correspondenceAddress.mobileNumber" 
    :customerEmailId="proposalDetailsData.correspondenceAddress.emailId" :paymentdb="completedb.paymentDetails" 
    :quoteId="completedb.quoteId" :premium="generateQuoteData.selectedPlan.totalPremium" :paymentDetailsData="paymentData" 
    :policyStartDate="policyStartDate" :generateQuoteData="generateQuoteData" :isCSCLogin="isCSCLogin" :encryptedObj="completedb.encryptedObject"
    @storePremiumPayerId="storePremiumPayerId" @validateEmailMobilePaymentLink="validateEmailMobilePaymentLink"></PaymentMethods>
    <span class="bor-der1"></span>
</div>
</template>

<script>
import PaymentMethods from "@/../../shared_motor_component/PaymentMethods.vue"
import ApplicationOverview from "./components/ApplicationOverview.vue"
import ToastNotification from "@/../../shared_component/ToastNotification.vue";
import { reactive, onMounted } from '@vue/composition-api';

export default {
  name: "PaymentModule",
  props : ['paymentData','generateQuoteData','policyStartDate','completedb','proposalDetailsData','currentStage','scpaDetails','isCSCLogin'],
   components: {
    PaymentMethods,
    ApplicationOverview,
    ToastNotification
  },
  setup(props, context){
    let state = reactive({
      showShareButton : false,
      showPayLaterButton : false,
      toastMsgType: '',
      messageFromServer: ''
    });
    // Mounted
    onMounted(()=>{
    })
    //methods
    function paymentBtn(paymentBtnSatus){
      context.emit('payNowButton', paymentBtnSatus);
    }
    function validateEmailMobilePaymentLink(){
      context.emit('validateEmailMobilePaymentLink');
    }
    function shareButton(stateBtn){
      context.emit('showShareButton', stateBtn);
      context.emit('showPayLaterButton', stateBtn);
    }
    function storePremiumPayerId(partyId){
      context.emit('storePremiumPayerId',partyId);
    }
    //return
    return{
      state,
      shareButton,
      paymentBtn,
      storePremiumPayerId,
      validateEmailMobilePaymentLink
    }
  }
};
</script>
<style>
.vdp-datepicker__calendar{
  width: auto! important;
}
</style>
<style scoped>
.tablecolor {
  background-color: rgba(30, 30, 30, 0.05);
}
.borderless th {
  border: none;
  padding-bottom: 0px;
  font-size: 10px;
  /* text-align: center; */
}
.borderless td {
  padding-top: 0px;
  padding-bottom: 0px;
  font-size: 14px;
  /* text-align: center; */
}
.table thead th {
  vertical-align: top;
}
.mobile-label{
    display: none; 
}
.bor-der1 {
  border-bottom: 1px solid #c7c7c7;
  width: 100%;
  display: inline-grid;
  position: relative;
  top: 20px;
}
.btndiv {
  margin-top: 45px;
  margin-right: 40px;
}
input[type="radio"].bgc-radio {
  z-index: 5;
  padding: 3px;
  width: 20px;
  height: 20px;
  cursor: pointer;
}

input[type="radio"].bgc-radio + label::before {
  top: 0px;
  left: -30px;
  cursor: default;
}
.custom-control-label::after{
  z-index: -1;
}
.heading-font{
  font-size: 16px;
  padding-top: .5em;
  padding-bottom: .5em ;
}
tr.table-border{
  border-bottom: .25px solid #b3b3b3;
}
td.space{
  padding-top: .5em ;
  padding-bottom: .5em ;
}
.drop[data-toggle="collapse"]::after {
  content: url(../../assets/images/search-up.png);
  padding-left: 9px;
}
.drop[data-toggle="collapse"].collapsed::after {
  content: url(../../assets/images/search-down.png);
  padding-left: 9px;
}
.payment-space{
  padding-top: 1em ;
  padding-bottom: .5em ;
}
.review-heading{
  font-size: 10px;
  font-weight: bold;
  color: #666666; 
}
</style>